// issue #124: exportar lo que ya está en pantalla — CSV primero, sin
// backend. Un CSV de verdad, no un ".csv" con comas sin escapar: una nota con
// coma o comillas rompería el archivo en Excel/Sheets silenciosamente.
function escapeCsvField(value: string | number): string {
  let str = String(value ?? '');
  // issue #157: los campos son texto libre del usuario (nota de un gasto,
  // relato de una novedad) — si empieza por = + - @, Excel/Sheets lo abre
  // como fórmula, no como texto. Antepone una comilla simple, el escape
  // estándar (OWASP CSV Injection); Excel la retira al mostrar el valor.
  // Solo para strings: un `number` que ya calculó la app (totales, montos
  // negativos) nunca es una fórmula tecleada por alguien, y prefijarlo
  // rompería esa columna numérica.
  if (typeof value === 'string' && /^[=+\-@]/.test(str)) {
    str = `'${str}`;
  }
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function exportToCsv(filename: string, rows: Record<string, string | number>[]): void {
  if (rows.length === 0) return;
  const headers = Object.keys(rows[0]);
  const lines = [
    headers.map(escapeCsvField).join(','),
    ...rows.map(row => headers.map(h => escapeCsvField(row[h])).join(',')),
  ];
  // BOM UTF-8: sin esto Excel abre acentos/ñ como caracteres sueltos.
  const blob = new Blob(['﻿' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
